import type { FC, ReactNode } from "react";
import { Header, Heading } from "react-aria-components";

export interface PageHeaderProps {
  backLink?: ReactNode;
  rightActions?: ReactNode;
  heading: ReactNode;
  subheading?: ReactNode;
  isLoading?: boolean;
}

/**
 * @deprecated The pre-redesign in-content page header. New and reworked pages
 * use the full-bleed `PageHeader` from `Navigation/pageHeader.tsx` instead.
 */
export const PageHeader: FC<PageHeaderProps> = (props) => {
  const renderHeadingContent = () => {
    if (props.heading) {
      return props.heading;
    }

    if (props.isLoading) {
      // Use h-9 so the loading state has the same height as the header
      return (
        <div className="h-9 w-60 py-1">
          <div className="h-full w-full animate-pulse rounded-full bg-gray-300" />
        </div>
      );
    }

    return null;
  };

  return (
    <Header className="flex flex-col gap-y-4">
      {props.backLink ? (
        <div className="flex items-center gap-2">{props.backLink}</div>
      ) : null}

      <div className="flex flex-col gap-y-1">
        <div className="flex items-center justify-between">
          <Heading
            level={2}
            className="text-2xl leading-9 font-semibold text-foreground"
          >
            {renderHeadingContent()}
          </Heading>
          <div className="flex items-center gap-2">{props.rightActions}</div>
        </div>

        {props.subheading}
      </div>
    </Header>
  );
};
